export default {
  firebase: {
    apiKey: 'AIzaSyBIOPpQmAvGAxE_IqADlI4tW96v8LmUNag',
    authDomain: 'uptrust-reminders---test-mig.firebaseapp.com',
    databaseURL: 'https://uptrust-reminders---test-mig.firebaseio.com',
    projectId: 'uptrust-reminders---test-mig',
    storageBucket: 'uptrust-reminders---test-mig.firebasestorage.app',
    messagingSenderId: '713254597205',
    appId: '1:713254597205:web:9ca13b42115e2b7f83dadc',
    measurementId: 'G-RWTPBWBSSR',
  },
  api: {
    url: 'https://api-testmigration.uptrust.co',
    wss: 'wss://api-testmigration.uptrust.co/graphql',
  },
  launchDarkly: {
    clientSideId: '60bff4368687860cdc0c318c',
  },
  datadogRUM: {
    applicationId: '6418ed95-72a0-4858-8e0a-16f99f052947',
    clientToken: 'pubd13d3055d1fd52f71e25cf93d9e3cb63',
    site: 'datadoghq.com',
    service: 'neo-staff-web',
    env: 'testmig',
    sampleRate: 100,
    version: import.meta.env.VITE_PUBLIC_VERSION,
    allowedTracingOrigins: ['https://api.uptrust.co'],
  },
};
